// Quiet placeholders the landing shows while its WebGL and canvas chunks
// load: the nebula on desktop, the sphere on every layout.

export function LandingNebulaFallback() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          "radial-gradient(circle at 68% 48%, rgba(34,211,238,0.15), transparent 34%), radial-gradient(circle at 36% 52%, rgba(167,139,250,0.11), transparent 32%), #020813",
      }}
    />
  );
}

// A quiet dotted shell in the sphere's palette holds its place while WebGL
// loads, so nothing brighter than the sphere flashes first.
export function NeuralSphereFallback() {
  const shell =
    "radial-gradient(circle, black 58%, rgba(0,0,0,0.35) 66%, transparent 71%)";
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 rounded-full"
      style={{
        backgroundImage:
          "radial-gradient(circle, rgba(234,251,255,0.42) 0.9px, transparent 1.4px), radial-gradient(circle, rgba(0,212,255,0.08), transparent 70%)",
        backgroundSize: "13px 13px, 100% 100%",
        maskImage: shell,
        WebkitMaskImage: shell,
      }}
    />
  );
}

export function LandingSceneFallback() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 5 }}
    >
      <div className="absolute left-[-8%] top-[14%] h-[58vh] w-[42vw] rounded-full bg-cyan-400/[0.05] blur-3xl" />
      <div className="absolute right-[10%] top-[24%] h-[46vh] w-[32vw] rounded-full bg-fuchsia-300/[0.04] blur-3xl" />
    </div>
  );
}
